import { createStyles, Tooltip, Typography, WithStyles, withStyles } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import React from 'react'

const styles = () =>
  createStyles({
    tooltip: {
      verticalAlign: 'middle',
      'margin-left': '1ch',
    },
  })

interface IFieldTitleProps extends WithStyles {
  title: string
  tooltip?: string
}

function FieldTitleComponent(props: IFieldTitleProps) {
  return (
    <Typography variant="h6">
      {props.title}
      {props.tooltip && (
        <Tooltip title={<h3 style={{ fontSize: 'small' }}>{props.tooltip}</h3>} className={props.classes.tooltip}>
          <InfoIcon />
        </Tooltip>
      )}
    </Typography>
  )
}
const FieldTitle = withStyles(styles)(FieldTitleComponent)
export { FieldTitle }
